import Login from "../../components/Login";

export const LoginPage = () => {
  return (
    <div className="relative flex flex-1 w-full items-center justify-center bg-gray-50 px-6 py-12">
      <div className="relative z-10 w-full max-w-md bg-white rounded-3xl border border-gray-100 shadow-xl px-10 py-12">
        <div className="absolute top-0 left-10 right-10 h-1 rounded-b-full"
          style={{ background: "linear-gradient(90deg, #7c3aed, #4f46e5, #a21caf)" }} />
        <Login />
      </div>
    </div>
  );
};
